import React from 'react'
import ListItem from './ListItem'

function mapListing(item, index) {
  const {limit} = this
  if (index >= limit) { return '' }
  const finalProps = Object.assign({key: item.id, item: item}, {...this})
  return (<ListItem {...finalProps}/>)
}

const Listing = (props) => {
  const {data} = props
  let itemProps = Object.assign({}, {...props})
  delete itemProps.data
  return (
    <div className="list">
      <div className="list-wrapper">
        {data.map(mapListing, {...itemProps})}
      </div>
    </div>
  )
}

export default Listing



// WEBPACK FOOTER //
// ./assets/js/components/list/Listing.jsx